import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: {
                link: 'show'
            },
            mouseleave: {
                link: 'hide'
            }
        }
    }

    init() {

    }

    show(e) {
        e.preventDefault()

        const el = e.curTarget
        const img = this.getData('category', el)

        this.$('img')[0].classList.add('is-active')
        this.$('img')[0].setAttribute("src", img);

    }

    hide() {
        this.$('img')[0].classList.remove('is-active')
    }

}
